import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface ChangelogPanelProps {
  isOpen: boolean;
  onToggle: () => void;
}

const CHANGELOG_VERSIONS = [
  {
    version: "v1",
    changes: [
      "Cassation and Cour d'appel jurisprudence search",
      "Smart page ranking and search optimisations for case law",
    ],
  },
  {
    version: "v0.6",
    changes: [
      "Faster and more reliable updates of collective agreements and the Code du travail",
      "More stable answers — fixed a bug that could interrupt a reply mid-way",
      "Improved handling of long legal texts when searching and answering",
    ],
  },
  {
    version: "v0.5",
    changes: ["Modification of the search logic for improved speed."],
  },
  {
    version: "v0.4",
    changes: [
      "Law explorer module which allows to browse the Code du travail articles and sections",
      "Improvement on the initial context provided to the agent",
    ],
  },
  {
    version: "v0.3",
    changes: [
      "Link references to Code du travail are now correctly handled (L. 1234-1, etc.)",
      "Fix a bunch of markdown rendering issues",
    ],
  },
  {
    version: "v0.2",
    changes: [
      "Support for Code du travail",
      "Reworked indexing for law textual content, enabling new experience later on",
      "Better mobile phone support with expanded view",
      "Auto-linking of article references (L. 1234-1, etc.)",
    ],
  },
  {
    version: "v0.1",
    changes: [
      "Initial release",
      "Collective agreement database research",
      "Source citations with Legifrance links",
    ],
  },
];

const CHANGELOG_CONTENT = `
${CHANGELOG_VERSIONS.map((version) => `## ${version.version}\n\n${version.changes.map((change) => `- ${change}`).join("\n")}`).join("\n")}
`;

export function ChangelogPanel({ isOpen, onToggle }: ChangelogPanelProps) {
  return (
    <>
      {/* Toggle Button - bottom left, hidden on mobile */}
      <button
        className="changelog-toggle"
        onClick={onToggle}
        aria-label={isOpen ? "Fermer le changelog" : "Voir le changelog"}
        aria-expanded={isOpen}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
        <span className="changelog-version">{CHANGELOG_VERSIONS[0]?.version}</span>
      </button>

      {/* Overlay */}
      {isOpen && <div className="changelog-overlay" onClick={onToggle} />}

      {/* Panel */}
      <aside className={`changelog-panel ${isOpen ? "is-open" : ""}`}>
        <div className="changelog-header">
          <h3 className="changelog-title">Changelog</h3>
          <button className="changelog-close" onClick={onToggle} aria-label="Fermer">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="changelog-content">
          <Markdown remarkPlugins={[remarkGfm]}>{CHANGELOG_CONTENT}</Markdown>
        </div>
      </aside>
    </>
  );
}
